export const SDK_VERSION = '0.9.5';